module.exports = __webpack_public_path__ + "static/logo-two-70cc9ee186072b48fb3823e895d263a2.png";